import { render, staticRenderFns } from "./growupRecord.vue?vue&type=template&id=5ce5bdbf&scoped=true&"
import script from "./growupRecord.vue?vue&type=script&lang=js&"
export * from "./growupRecord.vue?vue&type=script&lang=js&"
import style0 from "./growupRecord.vue?vue&type=style&index=0&id=5ce5bdbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5bdbf",
  null
  
)

export default component.exports